<template>
  <!-- 信用卡填寫視窗 -->
  <ui-modal ref="creditCardQuestionModal" :header-title="$t('credit_card_guide')" :forcing="true" :hide-overlay="false">
    <div class="credit-card-question__content">
      <v-img class="mb-7" :max-width="260" cover src="@/assets/images/payment/credit-card-guide.png" />

      <div class="guide-list__box">
        <div v-for="(guide, idx) in guideList" :key="idx" class="guide-list">
          <div class="guide-list__number">{{ idx + 1 }}</div>
          <div class="guide-list__text">{{ guide.text }}</div>
        </div>
      </div>
    </div>
  </ui-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import tools from '@/mixin/tools'

import UiModal from '@/components/dialog/ui-modal.vue'

export default {
  name: 'CreditCardQuestionModal',
  components: {
    UiModal,
  },
  mixins: [tools],
  props: {},
  data() {
    return {}
  },
  computed: {
    guideList() {
      return [{ text: this.$t('credit_card_no') }, { text: this.$t('credit_card_expire_date') }, { text: this.$t('credit_card_cvv') }]
    },
    ...mapGetters({}),
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    showModal() {
      this.$refs.creditCardQuestionModal.showModal()
    },
    hideModal() {
      this.$refs.creditCardQuestionModal.hideModal()
    },
  },
}
</script>

<style lang="scss" scoped>
.credit-card-question__content {
  max-width: 260px;
  max-height: calc(75vh - 68px);
  margin: auto;
  padding-bottom: 24px;
  overflow-y: auto;

  .guide-list__box {
    width: max-content;
    margin: auto;
    .guide-list {
      margin: 8px 0;
      display: flex;
      align-items: center;
      &__number {
        margin-right: 8px;
        width: 24px;
        height: 24px;
        border-radius: 24px;
        color: white;
        background-color: $orange50;
        text-align: center;
        font-weight: 500;
      }
      &__text {
      }
    }
  }
}
</style>
